import React, { createContext, useState } from 'react';

export const CourseEnrollmentsFilterStateContext = createContext();

const INITIAL_STATE = {
  filterObject: {},
  showFilters: true
};

const CourseEnrollmentsFilterContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <CourseEnrollmentsFilterStateContext.Provider value={stateHook}>
      {children}
    </CourseEnrollmentsFilterStateContext.Provider>
  );
};

export default CourseEnrollmentsFilterContextProvider;